<template>
  <main class="page">
    <Popup v-if="showPopup" :content="content" />

    <section class="page__intro">
      <h1 class="page__title">Din framtidsprognos</h1>
      <p>Baserat på ditt nuvarande sparande, ålder och planerad pensionsålder har vi tagit fram din framtidsprognos.</p>
    </section>
    <section class="page__main page__main--use-space">
      <div class="progress__chart">
        <ProgressChart :data="progressChartData"/>
      </div>
      <div class="progress__databoxes">
        <DataBox :data="dataBoxes.low" />
        <DataBox :data="dataBoxes.medium" />
        <DataBox :data="dataBoxes.high" />
      </div>

      <LifeStages />
    </section>
  </main>
</template>

<script>
import ProgressChart from '../components/elements/ProgressChart'
import LifeStages from '../components/elements/LifeStages'
import DataBox from '../components/elements/DataBox'
import Popup from '../components/elements/Popup.vue'
import fetch from '../services/fetch';

export default {
  name: 'Progress',
  components: { ProgressChart, LifeStages, Popup, DataBox },
  data() {
    return {
      progressChartData: [],
      showPopup: false,
      content: {
        title: 'Hej ' + this.$store.getters.user.firstName,
        text: 'Du behöver fylla i din månadslön för att kunna bestämma din framtidsprognos.',
        link_msg: 'Mina tillgångar',
        link: '/assets'
      },
      dataBoxes: {
        low: {
          title: 'Prognos låg',
          subtitle: 'Förväntad pension vid ',
          number: 0,
        },
        medium: {
          title: 'Prognos medel',
          subtitle: 'Förväntad pension vid ',
          number: 0,
        },
        high: {
          title: 'Prognos hög',
          subtitle: 'Förväntad pension vid ',
          number: 0,
        },
      }
    };
  },
  methods: {
    numberSpacing (nr) {
      return nr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
  },
  async mounted() {
    const { data, success } = await fetch.get('/prognosis').then(({ data }) => data);
    if (!success) {
      this.showPopup = true;
      return;
    }
    this.progressChartData = data;

    this.dataBoxes.low.number = this.numberSpacing(this.progressChartData.at(-1).low)
    this.dataBoxes.medium.number = this.numberSpacing(this.progressChartData.at(-1).medium)
    this.dataBoxes.high.number = this.numberSpacing(this.progressChartData.at(-1).high)
  },
}
</script>

<style lang="scss" scoped>
.progress {
  &__chart {
    margin: 2rem;
  }
  &__databoxes {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 2rem;
  }
}
</style>
